import { useAuth0 } from "@auth0/auth0-react";
import { AuthLayout } from "modules/auth/components/auth-layout";
import * as React from "react";
import { Button } from "shared";
import {
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  chakra,
  useDisclosure,
  Icon,
} from "@chakra-ui/react";
import { EmrLockWarning } from "@medstonetech/slate-icons";

const SESSION_TIMEOUT_KEY = "sessionTimeoutShown";

function SessionTimeoutModal(props: { isOpen: boolean; onClose: () => void }) {
  const { loginWithRedirect } = useAuth0();

  const handleLogin = () => {
    props.onClose();
    loginWithRedirect();
  };

  return (
    <Modal
      isCentered
      {...props}
      onClose={() => {}}
      closeOnOverlayClick={false}
      closeOnEsc={false}
    >
      <ModalOverlay />
      <ModalContent userSelect="none">
        <ModalHeader
          display="flex"
          justifyContent="center"
          flexDir="column"
          gap="35px"
          alignItems="center"
        >
          <Icon color="gray.700" fontSize="72px" as={EmrLockWarning} />
          <chakra.span fontWeight="600">You've been logged out!</chakra.span>
        </ModalHeader>
        <ModalBody display="flex" flexDir="column" justifyContent="center">
          <chakra.span textAlign="center">
            We noticed you aren't active in this session, so you have been
            logged out for your safety. <br /> <br /> Please click on the button
            to log in again.
          </chakra.span>
        </ModalBody>
        <ModalFooter justifyContent="center">
          <Button minW="287px" minH="52px" onClick={handleLogin}>
            Log In Again
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}

function Login() {
  const { loginWithRedirect } = useAuth0();
  const sessionTimeoutDisclose = useDisclosure();

  React.useEffect(() => {
    const timeoutShown = localStorage.getItem(SESSION_TIMEOUT_KEY);
    if (timeoutShown === "true") {
      sessionTimeoutDisclose.onOpen();
      localStorage.removeItem(SESSION_TIMEOUT_KEY);
    }
  }, [sessionTimeoutDisclose]);

  return (
    <AuthLayout>
      <Button
        type="submit"
        width="275px"
        onClick={() => loginWithRedirect()}
        margin="auto"
      >
        Sign In
      </Button>
      <SessionTimeoutModal
        isOpen={sessionTimeoutDisclose.isOpen}
        onClose={sessionTimeoutDisclose.onClose}
      />
    </AuthLayout>
  );
}

export { Login };
